module.exports = __webpack_public_path__ + "static/media/IMG-3172.65722d89.jpg";